import { Box, Divider, Typography } from "@mui/material";
import useApi from "hooks/useApi";
import { useEffect, useState } from "react";
import ReactLoading from "react-loading";

const SummaryBox = ({ title, items }) => (
  <Box
    sx={{
      padding: "20px",
      bgcolor: "#fff",
      borderRadius: "5px",
      boxShadow: "2px 1px 3px #e5e5e5",
      width: "fit-content",
    }}
  >
    <Typography mb={1}>{title}</Typography>
    <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
      {items?.map((item, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            pr: index === items.length - 1 ? 0 : "20px",
            borderRight: index === items.length - 1 ? "none" : "1px solid #ddd",
          }}
        >
          <Box
            sx={{
              height: "40px",
              width: "40px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#40518920",
              color: "#405189",
              fontWeight: "500",
              fontSize: "0.85rem",
            }}
          >
            {item?.currency_symbol}
          </Box>
          <Box>
            <Typography variant="h4">
              {/* {item?.currency_symbol}  */}
              {Number(item?.total)?.toFixed(2)}
            </Typography>
            <Typography fontSize="0.85rem">{item?.currency_name}</Typography>
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
);

const Summary = ({ filters, search }) => {
  const [summary, setSummary] = useState({});
  const { loading, fetchData } = useApi();

  useEffect(() => {
    const getInvoiceSummary = async () => {
      const endpoint = {
        method: "post",
        url: "api/admin/invoice/university-reference/summery",
        data: { ...filters, search },
      };
      const result = await fetchData(endpoint, false);
      setSummary(result?.data || {});
    };
    getInvoiceSummary();
  }, [search, filters]);

  return (
    <>
      {loading ? (
        <Box
          sx={{
            height: "calc(100vh - 145px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ReactLoading
            type="cylon"
            color="#405189"
            height={"85px"}
            width={"100px"}
          />
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
              gap: "20px",
              padding: "20px 20px",
              borderTop: "1px solid #ddd",
            }}
          >
            {!!summary?.status_summery &&
              summary?.status_summery?.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    bgcolor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    boxShadow: "2px 1px 3px #e5e5e5",
                  }}
                >
                  <Typography>
                    {item?.status &&
                      item.status.charAt(0).toUpperCase() +
                        item.status.slice(1)}
                  </Typography>
                  <Typography variant="h3">{item?.total || 0}</Typography>
                </Box>
              ))}
          </Box>

          <Divider />

          <Box
            sx={{
              p: "20px",
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            <SummaryBox
              title="Total Due"
              items={summary?.currency_summery?.unpaid}
            />
            <SummaryBox
              title="Total Paid"
              items={summary?.currency_summery?.paid}
            />
            <SummaryBox
              title="Total Payable"
              items={summary?.currency_summery?.payable}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default Summary;
